export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOG_OUT = 'USER_LOG_OUT';
export const SWITCH_ENVIRONMENT = 'SWITCH_ENVIRONMENT'
export const GET_ENVIRONMENTS = 'GET_ENVIRONMENTS'
export const LOAD_ORG_CONFIG = 'LOAD_ORG_CONFIG'